<template>
    <div>
        <template v-for="(item,index) of configs">
            <diverse-input :ref="inputName(index)"
                           :config="item"
                           :value.sync="values[item.name]"
                           :key="index"
                           class="mt-1"
                           horizontal
                           @change="$emit('change',{key: item.name, value: $event})">
            </diverse-input>
        </template>
    </div>
</template>

<script>
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "DiverseInputGroup",
    components: {DiverseInput},
    mixins: [emCommonUtilMixin],
    props: {
        configs: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            values: {},
        }
    },
    watch: {
        values: {
            handler() {
                this.$emit('changed', this.getInputData());
            },
            deep: true
        }
    },
    created() {
        for (let item of this.configs) {
            if (item.hasOwnProperty('defaultValue')) {
                this.values[item.name] = item.defaultValue;
            }
            if (item.hasOwnProperty('optionsFromDict')) {
                this.$store.dispatch('dictionaryEnumStore/queryDictionary', item.optionsFromDict);
            }
        }
    },
    methods: {
        inputName(index) {
            return 'DI' + index;
        },
        isComplete() {
            for (let i = 0; i < this.configs.length; i++) {
                if (!this.$refs[this.inputName(i)][0].isValidated()) {
                    return false;
                }
            }
            return true;
        },
        getInputData() {
            if (this.isComplete()) {
                return this.deepCopyObj(this.values);
            }
        },
        initInputData(values) {
            let temp = this.deepCopyObj(values);
            this.copyObj2Obj(temp, this.values, true);
            this.$forceUpdate();
        }
    }
}
</script>

<style scoped>

</style>
